<div class="companies-page">
  <div class="page-header">
    <div class="header-text">
      <h2>Checklists</h2>
      <p>Selecione a empresa para visualizar os checklists</p>
    </div>
    @if (companies.length > 0) {
      <div class="header-actions">
        <input
          nz-input
          class="search-input"
          placeholder="Buscar empresa"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
        />
      </div>
    }
  </div>

  <nz-spin [nzSpinning]="companiesLoader | async">
    @if (!(companiesLoader | async) && filteredCompanies.length === 0) {
      <div class="companies-empty">
        <nz-empty
          nzNotFoundImage="simple"
          [nzNotFoundContent]="
            searchTerm
              ? 'Nenhuma empresa encontrada para a busca'
              : 'Nenhuma empresa cadastrada'
          "
        ></nz-empty>
      </div>
    } @else {
      <div class="companies-grid">
        @for (item of filteredCompanies; track item.id) {
          <button
            type="button"
            class="company-card"
            (click)="handleOpenList(item.id)"
          >
            <div class="company-card__avatar">
              @if (item.logo) {
                <az_avatar
                  [src]="item.logo"
                  [shape]="'square'"
                  [size]="56"
                  [useDefault]="true"
                ></az_avatar>
              } @else {
                <span class="company-card__initials" aria-hidden="true">
                  {{ companyInitials(item.name) }}
                </span>
              }
            </div>

            <div class="company-card__body">
              <strong class="company-card__name">{{ item.name }}</strong>
              <span class="company-card__hint">Ver checklists</span>
            </div>

            <span class="company-card__arrow" nz-icon nzType="right" nzTheme="outline"></span>
          </button>
        }
      </div>
    }
  </nz-spin>
</div>
